import { motion } from "framer-motion";
import languages from "../Data/Languages/Languages";
import skills from "../Data/Skills/Skills";
import Resume from "../../assets/Resume/Sertaç Gültekin - Resume.pdf";
import termessss from "../../assets/Resume/termessss.jpeg";

const Home = () => {
  return (
    <div
      className="flex h-screen bg-gray-900 "
      style={{ background: "linear-gradient(to right, black, black)" }}
    >
      <div
        className="w-1/2 flex flex-col justify-center items-center"
        style={{ textAlign: "center" }}
      >
        {languages.map((language, index) => (
          <motion.span
            key={index}
            className="text-4xl font-bold "
            style={{
              color: `hsl(140, ${(index * 100) / languages.length}%, 50%)`,
              fontFamily: ["Montserrat", "Roboto", "Open Sans"][index % 3],
              marginRight: "8px",
            }}
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{
              duration: 2.0,
              delay: index * 0.5,
              repeat: Infinity,
              repeatType: "mirror",
              repeatDelay: 2,
            }}
          >
            {language}
          </motion.span>
        ))}

        <motion.h1
          className="text-3xl font-bold"
          style={{
            fontFamily: ["Quicksand", "sans-serif"],
            background: "linear-gradient(to right, #0000, #949993, #87E878)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            position: "absolute",
            top: "28%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            mixBlendMode: "screen",
            zIndex: 1,
            textAlign: "center",
            maxWidth: "80vw",
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 2 } }}
        >
          <img
            src={termessss}
            className="rounded-full img-small"
            style={{ marginTop:"120px", padding:"160px" }}
          />
          <span
            style={{
              color: "gray",
              textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
              fontFamily: "Agdasima",
            }}
          >
            Hello, I am{" "}
          </span>
          <span
            style={{
              color: "#22FF00",
              textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
              fontFamily: "Agdasima",
            }}
          >
            SERTAÇ
          </span>
          <span
            style={{
              color: "gray",
              textShadow: "0px 2px 4px rgba(0, 0, 0, 0.5)",
              fontFamily: "Agdasima",
            }}
          >
            , a passionate frontend developer.
            <br />
            Welcome to my portfolio website!
          </span>
        </motion.h1>
        <div className="flex justify-end items-end  mt-6">
          <a
            href="https://www.linkedin.com/in/sertacgultekin/"
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mr-4"
          >
            Hire Me
          </a>
          <a href={Resume} download>
            <button className="bg-amber-500 hover:bg-amber-700 text-white font-bold py-2 px-4 rounded">
              Download Resume
            </button>
          </a>
        </div>
      </div>
      <div
        className="w-1/2 flex flex-col justify-center items-center "
        style={{
          background: "linear-gradient(to right, black, green)",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          className="w-4/5 h-4/5 flex flex-wrap justify-center items-start  "
          style={{
            maxWidth: "350px",
            maxHeight: "200px",
            marginTop: "-190px",
            marginRight: "-520px",
          }}
        >
          {skills.map((skill, index) => (
            <motion.div
              key={index}
              className="w-1/3 h-1/3 bg-cover bg-no-repeat bg-center rounded-lg p-px "
              style={{
                backgroundImage: `url(${skill.image})`,
                opacity: 0,
                boxShadow: "0 0 0 0 rgba(0, 255, 0, 1)",
              }}
              initial={{ opacity: 0 }}
              animate={{
                opacity: 1,
                boxShadow: "20px 20px 20px 20px rgba(0, 255, 0, 0.3)",
              }}
              transition={{
                duration: 2.0,
                delay: index * 0.2,
                repeat: Infinity,
                repeatType: "reverse",
              }}
            ></motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Home;
